import { getPropertySuspects } from "../api";
import { toast } from "react-toastify";

// Action types
export const SET_PROPERTY_SUSPECTS_LOADING = "SET_PROPERTY_SUSPECTS_LOADING";
export const SET_PROPERTY_SUSPECTS_DATA = "SET_PROPERTY_SUSPECTS_DATA";
export const SET_PROPERTY_SUSPECTS_ERROR = "SET_PROPERTY_SUSPECTS_ERROR";
export const SET_PROPERTY_SUSPECTS_CURSOR = "SET_PROPERTY_SUSPECTS_CURSOR";
export const SET_PROPERTY_SUSPECTS_HAS_NEXT_PAGE = "SET_PROPERTY_SUSPECTS_HAS_NEXT_PAGE";
export const SET_PROPERTY_SUSPECTS_TOTAL_COUNT = "SET_PROPERTY_SUSPECTS_TOTAL_COUNT";
export const SET_PROPERTY_SUSPECTS_CRS_VALUES = "SET_PROPERTY_SUSPECTS_CRS_VALUES";
export const RESET_PROPERTY_SUSPECTS = "RESET_PROPERTY_SUSPECTS";

// Action creators
export const setPropertySuspectsLoading = isLoading => ({
  type: SET_PROPERTY_SUSPECTS_LOADING,
  isLoading
});

export const setPropertySuspectsData = data => ({
  type: SET_PROPERTY_SUSPECTS_DATA,
  data
});

export const setPropertySuspectsError = error => ({
  type: SET_PROPERTY_SUSPECTS_ERROR,
  error
});

export const setPropertySuspectsCursor = cursor => ({
  type: SET_PROPERTY_SUSPECTS_CURSOR,
  cursor
});

export const setPropertySuspectsHasNextPage = hasNextPage => ({
  type: SET_PROPERTY_SUSPECTS_HAS_NEXT_PAGE,
  hasNextPage
});

export const setPropertySuspectsTotalCount = totalCount => ({
  type: SET_PROPERTY_SUSPECTS_TOTAL_COUNT,
  totalCount
});

export const setPropertySuspectsCrsValues = crsValues => ({
  type: SET_PROPERTY_SUSPECTS_CRS_VALUES,
  crsValues
});

export const resetPropertySuspects = () => ({
  type: RESET_PROPERTY_SUSPECTS
});

// Async action to fetch property suspects
export const asyncGetPropertySuspects = (cursor = null, size = 10, dispatch, forceRefresh = false) => {
  dispatch(setPropertySuspectsLoading(true));
  dispatch(setPropertySuspectsError(null));

  const payload = {
    cursor: cursor || "",
    size
  };

  // Only add timestamp when we need to force a refresh (bypass cache)
  if (forceRefresh) {
    payload.timestamp = Date.now();
  }

  return getPropertySuspects(payload)
    .then(response => {
      dispatch(setPropertySuspectsLoading(false));

      if (response.body && response.body.data && response.body.data.suspects) {
        const suspectsData = response.body.data.suspects;
        const responseData = response.body.data;

        dispatch(setPropertySuspectsData(suspectsData.suspects || []));
        dispatch(setPropertySuspectsCursor(suspectsData.nextCursor));
        dispatch(setPropertySuspectsHasNextPage(suspectsData.hasNextPage));
        if (suspectsData.totalCount != null) {
          dispatch(setPropertySuspectsTotalCount(suspectsData.totalCount));
        }
        if (responseData.crsValues) {
          dispatch(setPropertySuspectsCrsValues(responseData.crsValues));
        }
      } else {
        dispatch(setPropertySuspectsError("Invalid response format"));
        toast.error("Invalid response format");
      }
    })
    .catch(error => {
      dispatch(setPropertySuspectsLoading(false));
      dispatch(setPropertySuspectsError(error.message || "Failed to fetch property suspects"));
      toast.error("Failed to fetch property suspects");
      console.error("Error fetching property suspects:", error);
    });
};
